/**
 * Entity detail page — interactive behaviours
 *
 * Handles the chart-info popover (hover + click toggle) used by
 * buildInfoLabel() throughout entity-content.php.
 *
 * Relies on jQuery (declared as dependency in enqueue.php).
 */

jQuery(function ($) {
    "use strict";

    // ── Chart-info popover ─────────────────────────────────────────────────
    // Uses event delegation so it works regardless of when the elements are
    // rendered, and scopes each interaction to its own trigger/popover pair
    // via .closest() to avoid conflicts when multiple popovers exist.

    $(document).on("mouseenter", ".chart-info-btn", function () {
        var $trigger = $(this).closest(".chart-info-trigger");
        var $popover = $trigger.find(".chart-info-popover");
        clearTimeout($trigger.data("closeTimer"));
        $popover.stop(true, true).fadeIn(150);
    });

    $(document).on("mouseleave", ".chart-info-btn", function () {
        var $trigger = $(this).closest(".chart-info-trigger");
        var $popover = $trigger.find(".chart-info-popover");
        $trigger.data(
            "closeTimer",
            setTimeout(function () {
                $popover.stop(true, true).fadeOut(150);
            }, 120)
        );
    });

    $(document).on("mouseenter", ".chart-info-popover", function () {
        var $trigger = $(this).closest(".chart-info-trigger");
        clearTimeout($trigger.data("closeTimer"));
    });

    $(document).on("mouseleave", ".chart-info-popover", function () {
        var $trigger = $(this).closest(".chart-info-trigger");
        var $popover = $trigger.find(".chart-info-popover");
        $trigger.data(
            "closeTimer",
            setTimeout(function () {
                $popover.stop(true, true).fadeOut(150);
            }, 120)
        );
    });

    $(document).on("click", ".chart-info-btn", function (e) {
        e.stopPropagation();
        var $popover = $(this).closest(".chart-info-trigger").find(".chart-info-popover");
        $popover.is(":visible") ? $popover.stop(true, true).fadeOut(150) : $popover.stop(true, true).fadeIn(150);
    });
});
